//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var striptags = require('striptags')

export default {
  props: {
    cor: String,
    icone: String,
    rede: String,
    size: String,
    post: Object,
    hiddenTexto: Boolean,
  },
  data() {
    return {
      striptags,
    }
  },
  computed: {
    url: (v) => `https\:\/\/multiversa.com\/blog\/${v.post.slug}\/`,
  },
  methods: {
    strip(text) {
      return striptags(text)
    },
  },
}
